// Curated natural-language search seeds shown as click-to-search chips on
// the landing hero and the empty /search state.
//
// Why these are queries (not tags):
// - They demonstrate the product's *actual* primary capability — hybrid
//   semantic search over real-life situations, in plain English.
// - They model how a seeker would phrase their situation, not how the
//   data was categorized internally. This avoids vocabulary collision
//   with the structured Filters panel (life_area / obstacle / shift),
//   which is the single source for facet-based refinement on /search.
//
// Keep the list short (5–7) and emotionally varied — the goal is "ah,
// stories like mine exist here," not exhaustive coverage.
export const SEARCH_SUGGESTIONS = [
  'how can yoga help me',           // story 4 and 3 — atheism to clarity and post-cancer healing
  'caring for a sick loved one', // stories 2 & 3 — mother's cancer
  'losing a close person',          // story 4 — atheism to clarity (father) 
  'first heartbreak',          // story 1 — first love
  "can't focus",               // story 1 — obsession derailing studies
  'finding purpose',    // story 4 — rationalist crisis
  'when plans fall apart'    // story 3 — impossible wedding
        
];

// Shared placeholder so the search bar communicates the same thing on
// both the landing page and the search results page.
export const SEARCH_PLACEHOLDER =
  "Describe what you're going through — e.g. \"losing a parent\", \"finding faith\"";
